import { Box, Button, Card, Chip, Divider, useMediaQuery } from "@mui/material";
import React from "react";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { lighten } from "@mui/material";
import { filterToDate } from "./DialogFiltroData";
import { almenoUnFiltro, mappaOperatoriComparazione } from "./FiltriOrdini";
import { useState } from "react";
import { DeleteForever } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { filtriOrdiniDefault } from "../StoricoOrdini";
import TabelleEntries from "../../../TabelleEntries";
import { useTheme } from "@emotion/react";
const {logger} = useBSSLogger();

const ottieniFiltriAttivi = filtri => {
    const scfiltri = filtri?.filtriRicerca ?? null;

    const statiSelezionati = (scfiltri?.stati ?? []);
    const tipiSelezionati = (scfiltri?.tipispedizione ?? [])
    const campiRicercaSelezionati = (scfiltri?.campiRicerca ?? [])

    return {
        term: (scfiltri?.term ?? null) !== null,
        dadata: (scfiltri?.dadata ?? null) !== null,
        adata: (scfiltri?.adata ?? null) !== null,
        fatturato: (scfiltri?.fatturato ?? null) !== null,
        totaleordine: (scfiltri?.totaleordine ?? null) !== null,
        statiSelezionati: (statiSelezionati.length > 0),
        tipiSelezionati: (tipiSelezionati.length > 0),
        campiRicercaSelezionati: (campiRicercaSelezionati.length > 0)
    }
}

const FiltroTerm = ({filtri, setFiltri, labelPrefix = `${__t("labelfiltroterm")}: `, ChipProps = {}}) => {

    const scfiltri = filtri?.filtriRicerca ?? null;
    
    return (
        <Chip color={"primary"}
            label={`${labelPrefix}${scfiltri.term}`}
            onDelete={e => setFiltri({
                ...filtri,
                skip: 0,
                filtriRicerca: {
                    ...scfiltri,
                    term: null
                }
            })}
            {...ChipProps}
        />
    )
}

const FiltroData = ({filtri, setFiltri, ctx = 'da', labelPrefix = null, ChipProps = {}}) => {

    const scfiltri = filtri?.filtriRicerca ?? null;
    const dadata = scfiltri?.dadata ?? null;
    const adata = scfiltri?.adata ?? null;

    let filtriDataOrdine = Object.keys({dadata, adata}).reduce((obj, k) => ({
        ...obj,
        [k]: filterToDate(scfiltri?.[k] ?? null)
    }), {dadata: null, adata: null})

    if(labelPrefix === null){
        const label = `labelfiltro${ctx}data`
        labelPrefix = `${__t(label)}: `        
    }

    return (
        <Chip color={"primary"}
                label={`${labelPrefix}${filtriDataOrdine[`${ctx}data`]}`}
                onDelete={e => setFiltri({
                    ...filtri,
                    skip: 0,
                    filtriRicerca: {
                        ...scfiltri,
                        [`${ctx}data`]: null
                    }                                             
                })}
                {...ChipProps}
            />
    )
}

const FiltroFatturato = ({filtri, setFiltri, labelPrefix = `${__t("labelfiltrofatturato")}: `, ChipProps = {}}) => {

    const scfiltri = filtri?.filtriRicerca ?? null;

    return (
        <Chip color={"primary"}
                label={`${labelPrefix}${__t([true, "true"].includes(scfiltri.fatturato) ? "si" : "no")}`}
                onDelete={e => setFiltri({
                    ...filtri,
                    skip: 0,
                    filtriRicerca: {
                        ...scfiltri,
                        fatturato: null
                    }
                })}
                {...ChipProps}
            />
    )
}

const FiltroTotale = ({filtri, setFiltri, labelPrefix = `${__t("labelfiltrototale")}: `, ChipProps = {}}) => {

    const scfiltri = filtri?.filtriRicerca ?? null;

    return (
        <Chip color={"primary"}
                label={`${labelPrefix}${mappaOperatoriComparazione[scfiltri.operatore ?? 'eq']} ${scfiltri.totaleordine}`}
                onDelete={e => setFiltri({
                    ...filtri,
                    skip: 0,
                    filtriRicerca: {
                        ...scfiltri,
                        totaleordine: null,
                        operatore: "eq"
                    }
                    
                })}
                {...ChipProps}
            />
    )
}

const rimuoviDa = (scfiltri, contesto, darimuovere) => {
    let nuoviFiltri = (scfiltri?.[contesto] ?? []).filter(id => id !== darimuovere);
    if(Array.isArray(nuoviFiltri) && nuoviFiltri.length === 0){
        nuoviFiltri = null;
    }
    return nuoviFiltri;
}

const FiltroStato = ({idstato, stati, filtri, setFiltri, labelPrefix = `${__t("labelfiltrostato")}: `, ChipProps = {}}) => {

    const scfiltri = filtri?.filtriRicerca ?? null;
    const stato = stati[idstato];

    return (
        <Chip
            sx={{                                                        
                backgroundColor: stato.colorestato,
                color: stato.coloretesto,     
                "& .MuiChip-deleteIcon": {
                    backgroundColor: stato.colorestato,
                    color: stato.coloretesto,
                },
                "& .MuiChip-deleteIcon:hover": {
                    color: lighten(stato.colorestato, "0.9"),
                }                                                                                                                                                                    
            }}
            label={`${labelPrefix}${stato.codicestato}`}
            onDelete={e => setFiltri({
                ...filtri,
                skip: 0,
                filtriRicerca: {
                    ...scfiltri,
                    stati: rimuoviDa(scfiltri, "stati", idstato)
                }
            })}
            {...ChipProps}
        />
    )
}

const FiltroTipo = ({idtipo, tipispedizione, filtri, setFiltri, labelPrefix = `${__t("labelfiltrotipo")}: `, ChipProps = {}}) => {
    
    const scfiltri = filtri?.filtriRicerca ?? null;
    const tipo = tipispedizione.find(t => t.id === idtipo);

    logger.debug("mostro filtro per tipo", tipo)

    return (
        <Chip color={"primary"}                                            
            label={`${labelPrefix}${tipo.descrizione}`}
            onDelete={e => setFiltri({
                ...filtri,
                skip: 0,
                filtriRicerca: {
                    ...scfiltri,
                    tipispedizione: rimuoviDa(scfiltri, "tipispedizione", tipo.id) 
                }
            })}
            {...ChipProps}
        />
    )
}

const FiltroCampo = ({campiRicerca, campo, filtri, setFiltri, labelPrefix = `${__t("labelcampoincluso")}: `, ChipProps = {}}) => {
    
    const scfiltri = filtri?.filtriRicerca ?? null;
    
    return (
        <Chip color={"primary"}                                            
            label={`${labelPrefix}${campiRicerca[campo]}`}
            onDelete={e => setFiltri({
                ...filtri,
                skip: 0,
                filtriRicerca: {
                    ...scfiltri,
                    campiRicerca: rimuoviDa(scfiltri, "campiRicerca", campo) 
                }
            })}
            {...ChipProps}
        />
    )
}

const FiltriAttivi = ({filtri, setFiltri, campiRicerca, stati, tipispedizione}) => {

    const theme = useTheme();

    const isPhone = useMediaQuery(theme.breakpoints.down("sm"));

    const [filtriMostrati, setFiltriMostrati] = useState(3)

    const scfiltri = filtri?.filtriRicerca ?? null;

    const statiSelezionati = (scfiltri?.stati ?? []);
    const tipiSelezionati = (scfiltri?.tipispedizione ?? [])
    const campiRicercaSelezionati = (scfiltri?.campiRicerca ?? [])
    
    const filtriAttivi = ottieniFiltriAttivi(filtri)

    const commonFiltroProps = ({filtri, setFiltri})

    const comps = [
        ...(filtriAttivi.term ? [(
            <FiltroTerm {...commonFiltroProps} />
        )] : []),
        ...(filtriAttivi.dadata ? [(            
            <FiltroData {...commonFiltroProps} ctx="da" />
        )] : []),
        ...(filtriAttivi.adata ? [(            
            <FiltroData {...commonFiltroProps} ctx="a" />
        )] : []),
        ...(filtriAttivi.fatturato ? [(
            <FiltroFatturato {...commonFiltroProps} />
        )] : []),
        ...(filtriAttivi.totaleordine ? [(
            <FiltroTotale {...commonFiltroProps} />
        )] : []),
        ...(filtriAttivi.statiSelezionati ? statiSelezionati.map((idstato) => {
            return (
                <FiltroStato {...commonFiltroProps} key={idstato} idstato={idstato} stati={stati} />
            )
        }) : []),
        ...(filtriAttivi.tipiSelezionati ? tipiSelezionati.map((idtipo) => {
            return (
                <FiltroTipo {...commonFiltroProps} key={idtipo} idtipo={idtipo} tipispedizione={tipispedizione} />
            )
        }) : []),
        ...(filtriAttivi.campiRicercaSelezionati ? campiRicercaSelezionati.map((campo, i) => {
            return (
                <FiltroCampo {...commonFiltroProps} campo={campo} key={i} campiRicerca={campiRicerca} />
            )
        }) : [])
    ]

    const nfiltriattivi = comps.length;

    let tabelleFiltri = {
        [__t("filtriattivi")]: {}
    }

    if(filtriAttivi.term || filtriAttivi.campiRicercaSelezionati){
        tabelleFiltri[__t("filtriattivi")][__t("term")] = (
            <>
                {filtriAttivi.term && (
                    <FiltroTerm {...commonFiltroProps} />
                )}
                {(filtriAttivi.term && filtriAttivi.campiRicercaSelezionati) && (
                    <Divider sx={{mt: 0.5, mb: 0.5}} />
                )}
                {filtriAttivi.campiRicercaSelezionati && campiRicercaSelezionati.map((campo, i) => {
                    return (
                        <FiltroCampo {...commonFiltroProps} campo={campo} key={i} campiRicerca={campiRicerca} />
                    )
                })}
            </>
        )
    }

    if(filtriAttivi.dadata || filtriAttivi.adata){
        tabelleFiltri[__t("filtriattivi")][__t("data")] = (
            <>
                {filtriAttivi.dadata && (
                    <FiltroData {...commonFiltroProps} ctx="da" />                
                )}
                {filtriAttivi.adata && (
                    <FiltroData {...commonFiltroProps} ctx="a" />
                )}
            </>
        )
    }

    if(filtriAttivi.fatturato){
        tabelleFiltri[__t("filtriattivi")][__t("fatturato")] = (
            <>
                <FiltroFatturato {...commonFiltroProps} />
            </>
        )
    }

    if(filtriAttivi.totaleordine){
        tabelleFiltri[__t("filtriattivi")][__t("totale")] = (
            <>
                <FiltroTotale {...commonFiltroProps} />
            </>
        )
    }

    if(filtriAttivi.tipiSelezionati){
        tabelleFiltri[__t("filtriattivi")][__t("tipospedizione")] = (
            <>
                {tipiSelezionati.map((idtipo) => {
                    return (
                        <FiltroTipo {...commonFiltroProps} key={idtipo} idtipo={idtipo} tipispedizione={tipispedizione} />
                    )
                })}
            </>
        )
    }

    if(filtriAttivi.statiSelezionati){
        tabelleFiltri[__t("filtriattivi")][__t("statospedizione")] = (
            <>
                {statiSelezionati.map((idstato) => {
                    return (
                        <FiltroStato {...commonFiltroProps} key={idstato} idstato={idstato} stati={stati} />
                    )
                })}
            </>
        )
    }

    return (<>
        {(almenoUnFiltro(filtri) !== false) && (
            <Card sx={{
                p: 1, 
                backgroundColor: grey[100]
            }}>
                {(!isPhone) && (
                    <TabelleEntries wrapped  tabelle={tabelleFiltri} />                                
                )}
                
                {(isPhone) && (
                    <>
                    
                        <i>{__t("risultatifiltratiper")}:{" "}</i> 
                        
                        {comps
                            .filter((c, i) => i+1 <= filtriMostrati)
                            .map((Comp, indice) => {
                                return (
                                    <Box py={1} pl={1} display={"inline"}>
                                        {Comp}
                                    </Box>
                                )
                            })
                        }

                    </>
                )}
                

                <Box sx={{py: 2, clear: "both"}}>
                    <Divider />
                </Box>

                {/* <Box py={1} pl={1}  display={"inline"}>

                    {nfiltriattivi > filtriMostrati && (
                        <Button variant="outlined" startIcon={<ExpandMore />} color="primary" onClick={e => setFiltriMostrati(999)}>
                            {__t("mostratutti")} 
                        </Button>                                        
                    )}
                    
                    {filtriMostrati === 999 && (
                        <Button  variant="outlined" startIcon={<ExpandLess />} color="primary" onClick={e => setFiltriMostrati(3)}>
                            {__t("mostrameno")} 
                        </Button>    
                    )}
                    
                </Box> */}

                <Box py={1} pl={1}  display={"inline"}>
                    <Button variant="outlined" startIcon={<DeleteForever />} color="error" onClick={e => {
                        setFiltri({skip: 0, filtriRicerca: filtriOrdiniDefault})
                        setFiltriMostrati(3)
                    }}>
                            {__t("rimuovitutti")} 
                        </Button>           
                </Box>
                
            
            </Card>
        )}
    </>)
}

export default FiltriAttivi;
export {ottieniFiltriAttivi}